import React from 'react';
import Middle from "Components/Middle";
import Button from "UI/Button";
import { Link } from 'react-router-dom';

import { BookmarkIcon } from "@heroicons/react/outline";

export default class BlankPosts extends React.Component
{
    render()
    {
        return <Middle>
            <div className='text-center'>
                <p>No posts to display.</p>
                <div className='space-x-2 mt-4'>
                    <Button component={Link} to='/stories' size='xs'><BookmarkIcon className='w-4 mr-1' /> View Stories</Button>
                </div>
            </div>
        </Middle>;
    }
}